import lux from "@/assets/1742561569_3593189334595606656.webp";
import couple from "@/assets/1779847500_3905966368420069795.webp";
import pine from "@/assets/1779947897_3906808566430270185.webp";
import bust from "@/assets/1780018027_3907396849912522036.webp";

export type FragranceNotes = {
  top: string;
  heart: string;
  base: string;
};

export type Product = {
  id: string;
  name: string;
  price: number;
  compareAt?: number;
  rating: number;
  reviews: number;
  img: string;
  tag?: string;
  category: "Luxury" | "Artisan" | "Decorative" | "Aroma" | "Gift Sets";
  fragrance: "Floral" | "Fruity" | "Woody" | "Fresh" | "Sweet";
  color: "gold" | "cream" | "green" | "rose";
  inStock: boolean;
  newest: number;
  popularity: number;
  fragranceNotes?: FragranceNotes;
  scentDescription?: string;
  fragranceOptions?: string[];
};

export const products: Product[] = [
  {
    id: "1",
    name: "Rose Couple Candle",
    price: 899,
    compareAt: 1199,
    rating: 4.9,
    reviews: 120,
    img: couple,
    tag: "Bestseller",
    category: "Artisan",
    fragrance: "Floral",
    color: "rose",
    inStock: true,
    newest: 12,
    popularity: 98,
    fragranceNotes: {
      top: "Bulgarian Rose & Pink Peony",
      heart: "Wild Velvet Rose & Honeycomb",
      base: "Warm Amber & Royal Sandalwood"
    },
    scentDescription: "Iss candle ko jalate hi kamre me taaza gulaab ki mehak phailti hai, jisme halki shahad aur ambar ki garmahat milti hai — a perfect romantic mood scent.",
    fragranceOptions: [
      "Velvet Rose & Honey (Romantic Floral)",
      "Rose & Pink Peony (Soft Blossom)",
      "Smoked Rose & Oud (Luxe Deep Floral)"
    ]
  },
  {
    id: "2",
    name: "Pineapple Sculpt",
    price: 649,
    compareAt: 799,
    rating: 4.8,
    reviews: 98,
    img: pine,
    tag: "New",
    category: "Decorative",
    fragrance: "Fresh",
    color: "green",
    inStock: true,
    newest: 20,
    popularity: 90,
    fragranceNotes: {
      top: "Tropical Pineapple & Crisp Bergamot",
      heart: "Green Leaves & Coconut Water",
      base: "White Musk & Vetiver"
    },
    scentDescription: "A refreshing burst of juicy tropical pineapple combined with cool green botanical notes — jisse kamre me taza aur energetic mahool banta hai.",
    fragranceOptions: [
      "Tropical Pineapple & Mint (Zesty Fresh)",
      "Pineapple & Coconut Cream (Sweet Breeze)",
      "Citrus Bergamot & Green Leaf (Crisp Aroma)"
    ]
  },
  {
    id: "3",
    name: "Crystal Glow Votives",
    price: 799,
    rating: 4.9,
    reviews: 156,
    img: lux,
    tag: "Limited",
    category: "Luxury",
    fragrance: "Woody",
    color: "gold",
    inStock: true,
    newest: 18,
    popularity: 95,
    fragranceNotes: {
      top: "Golden Saffron & Cardamom",
      heart: "Smoky Cedarwood & Patchouli",
      base: "Rich Amber & Aged Leather"
    },
    scentDescription: "Ek shahi aur gehri woody mehak jisme saffron aur cedarwood ki ameer khushboo hai — rooms feel warm, cozy, and ultra-luxurious.",
    fragranceOptions: [
      "Golden Amber & Oud (Royal Woody)",
      "Cedarwood & Vanilla (Warm Spice)",
      "Smoky Leather & Tobacco (Opulent Warmth)"
    ]
  },
  {
    id: "4",
    name: "Rose Bust Candle",
    price: 999,
    compareAt: 1299,
    rating: 4.7,
    reviews: 87,
    img: bust,
    tag: "Artisan",
    category: "Artisan",
    fragrance: "Floral",
    color: "rose",
    inStock: true,
    newest: 8,
    popularity: 80,
    fragranceNotes: {
      top: "Fresh Damask Rose & Lychee",
      heart: "Geranium & Jasmine Petals",
      base: "White Musk & Sandalwood"
    },
    scentDescription: "An elegant sculptural candle emitting a intoxicating damask rose floral aroma that lingers subtly for hours.",
    fragranceOptions: [
      "Damask Rose & Lychee (Sweet Floral)",
      "Jasmine & French Rose (Pure Floral)",
      "Rose Wood & Musk (Earthy Rose)"
    ]
  },
  {
    id: "5",
    name: "Aroma Soy Candle",
    price: 599,
    rating: 4.6,
    reviews: 87,
    img: lux,
    category: "Aroma",
    fragrance: "Sweet",
    color: "gold",
    inStock: true,
    newest: 5,
    popularity: 72,
    fragranceNotes: {
      top: "Sweet Vanilla Nectar & Almond",
      heart: "Toasted Caramel & Tonka Bean",
      base: "Warm Cream & Oakwood"
    },
    scentDescription: "Mano warm bakery se tazi vanilla aur caramel ki mehak aa rahi ho — soothing, sweet, and comforting scent.",
    fragranceOptions: [
      "Toasted Caramel & Vanilla (Gourmand Sweet)",
      "Almond Milk & Tonka (Creamy Soothing)",
      "Honeyed Vanilla Bean (Rich Sweet)"
    ]
  },
  {
    id: "6",
    name: "Luxury Gift Set",
    price: 1299,
    compareAt: 1599,
    rating: 4.9,
    reviews: 204,
    img: couple,
    tag: "Gift",
    category: "Gift Sets",
    fragrance: "Woody",
    color: "cream",
    inStock: true,
    newest: 15,
    popularity: 99,
    fragranceNotes: {
      top: "French Lavender & Sweet Orange",
      heart: "Amber Resin & Kashmiri Oud",
      base: "Mysore Sandalwood & Vanilla"
    },
    scentDescription: "Trio of signature luxury fragrances in one curated box — covering relaxing lavender, rich oud, and warm vanilla tones.",
    fragranceOptions: [
      "Curated Trio (Lavender, Amber Oud, Vanilla)",
      "Royal Woody Edit (Oud, Sandalwood, Cedar)",
      "Blossom & Spice Trio (Rose, Jasmine, Saffron)"
    ]
  },
  {
    id: "7",
    name: "Lotus Bloom Candle",
    price: 699,
    rating: 4.7,
    reviews: 63,
    img: pine,
    category: "Decorative",
    fragrance: "Floral",
    color: "green",
    inStock: true,
    newest: 10,
    popularity: 68,
    fragranceNotes: {
      top: "Water Lotus & Green Tea",
      heart: "White Lily & Dewy Eucalyptus",
      base: "Clean Musk & Driftwood"
    },
    scentDescription: "Pure and serene watery floral scent inspired by fresh morning lotus petals in full bloom.",
    fragranceOptions: [
      "Water Lotus & Green Tea (Serene Floral)",
      "White Lily & Dew (Crisp Botanical)",
      "Eucalyptus & Lotus (Spa Relaxation)"
    ]
  },
  {
    id: "8",
    name: "Vanilla Luxe Candle",
    price: 749,
    rating: 4.8,
    reviews: 73,
    img: bust,
    category: "Aroma",
    fragrance: "Sweet",
    color: "cream",
    inStock: false,
    newest: 3,
    popularity: 60,
    fragranceNotes: {
      top: "Madagascar Vanilla Pods",
      heart: "Warm Nutmeg & Bourbon",
      base: "Cashmere & Golden Amber"
    },
    scentDescription: "Rich Madagascar vanilla bean blended with warm cashmere and golden amber — deeply comforting and luxurious.",
    fragranceOptions: [
      "Madagascar Vanilla & Amber (Luxe Warmth)",
      "Bourbon Vanilla & Spice (Cozy Evening)",
      "Cashmere & Sweet Vanilla (Soft Velvet)"
    ]
  },
  {
    id: "9",
    name: "Ocean Breeze Candle",
    price: 599,
    rating: 4.6,
    reviews: 69,
    img: lux,
    category: "Aroma",
    fragrance: "Fresh",
    color: "cream",
    inStock: true,
    newest: 22,
    popularity: 78,
    fragranceNotes: {
      top: "Sea Salt & Italian Lemon",
      heart: "Ocean Spray & Sage",
      base: "Sun-bleached Driftwood & Amber"
    },
    scentDescription: "Fresh coastal breeze with crisp sea salt and sea sage — instant feeling of openness and tranquility.",
    fragranceOptions: [
      "Sea Salt & Driftwood (Coastal Marine)",
      "Ocean Spray & Lemon Zest (Bright Fresh)",
      "Cool Sage & Breeze (Calming Spa)"
    ]
  },
  {
    id: "10",
    name: "Lavender Dream Candle",
    price: 679,
    rating: 4.7,
    reviews: 115,
    img: bust,
    category: "Aroma",
    fragrance: "Floral",
    color: "rose",
    inStock: true,
    newest: 14,
    popularity: 85,
    fragranceNotes: {
      top: "Provence French Lavender",
      heart: "Chamomile & Spearmint",
      base: "Cedarwood & Soft Vanilla"
    },
    scentDescription: "Soothing French lavender blended with chamomile and soft cedarwood — designed for peaceful sleep and deep relaxation.",
    fragranceOptions: [
      "French Lavender & Chamomile (Sleep Therapy)",
      "Lavender & Vanilla Bean (Gentle Calming)",
      "Lavender & Eucalyptus (Purifying Fresh)"
    ]
  },
  {
    id: "11",
    name: "Amber Nights",
    price: 1099,
    compareAt: 1399,
    rating: 4.9,
    reviews: 142,
    img: couple,
    tag: "Limited",
    category: "Luxury",
    fragrance: "Woody",
    color: "gold",
    inStock: true,
    newest: 25,
    popularity: 93,
    fragranceNotes: {
      top: "Smoky Oud & Bergamot",
      heart: "Warm Baltic Amber & Cinnamon",
      base: "Dark Vanilla, Leather & Tobacco Leaf"
    },
    scentDescription: "A seductive dusk candle infused with smoky oud, Baltic amber, and rich dark vanilla — turning room light into pure velvet ambiance.",
    fragranceOptions: [
      "Smoky Oud & Baltic Amber (Dusk Luxury)",
      "Amber & Dark Vanilla (Seductive Warmth)",
      "Oud, Cinnamon & Leather (Spiced Opulence)"
    ]
  },
  {
    id: "12",
    name: "Emerald Pine Sculpt",
    price: 799,
    rating: 4.5,
    reviews: 44,
    img: pine,
    category: "Decorative",
    fragrance: "Woody",
    color: "green",
    inStock: true,
    newest: 7,
    popularity: 55,
    fragranceNotes: {
      top: "Siberian Pine & Crisp Juniper",
      heart: "Balsam Fir & Clove Blossom",
      base: "Oakmoss & Cedar Bark"
    },
    scentDescription: "Crisp pine forest fragrance with balsam fir and clove — brings the calm freshness of ancient mountain pine woods indoors.",
    fragranceOptions: [
      "Siberian Pine & Balsam Fir (Forest Fresh)",
      "Juniper & Cedar Bark (Resinous Wood)",
      "Pine & Spiced Clove (Holiday Hearth)"
    ]
  },
];

export const categories = ["Luxury", "Artisan", "Decorative", "Aroma", "Gift Sets"] as const;
export const fragrances = ["Floral", "Fruity", "Woody", "Fresh", "Sweet"] as const;
export const colors = [
  { key: "gold", hex: "#C8A165" },
  { key: "cream", hex: "#E8D0A9" },
  { key: "green", hex: "#3F8F5E" },
  { key: "rose", hex: "#B85450" },
] as const;

